import React, { useState } from "react";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";

import { SectionBackground } from "./_AboutUsStyles";
import imgIvonne from "../../images/ivonne-atmojo.jpg";
import imgIvana from "../../images/ivana-atmojo.jpg";
import images from "../../images/press/images";

export default () => {
  const [photoIndex, setPhotoIndex] = useState(0);
  const [isOpen, setIsOpen] = useState(false);

  const toggleShow = () => setIsOpen(!isOpen);
  const handlePhotoClick = e => {
    toggleShow();
    setPhotoIndex(e);
  };

  return (
    <section className="section_padding">
      <section>
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-12">
              <div className="section_title text-center">
                <h2>About Us</h2>
              </div>
            </div>
          </div>
        </div>
      </section>
      <SectionBackground>
        <div className="container">
          <div className="row">
            <div className="col-md-3 mx-auto">
              <img
                src={imgIvonne}
                alt="Ivonne Atmojo"
                className="img-fluid rounded-circle"
              />
              <h3 className="my-3 text-center">Ivonne Atmojo</h3>
            </div>
            <div className="col-md-8 mx-auto">
              <p>
                <b>Ivonne Atmojo, M.Mus</b> is a passionate music educator,
                specializing in teaching piano, vocal, &amp; choir. She
                completed her undergraduate studies with a double major in
                Biochemistry &amp; Music Performance at the University of
                Wisconsin – Madison, USA. Upon graduation, she worked as a
                Laboratory Analyst at Abbott Laboratory in Illionis. In her
                spare time, she taught music, performed, and prepared audition
                material for graduate school. Her Master of Music degree was
                received from San Francisco Conservatory of Music in 2004.
              </p>
              <p>
                She had done numerous solo piano recitals and collaborative
                concerts throughout the US, Europe, and Asia. Her passion in
                teaching music has landed her many invitations to give lecture
                demonstrations in many music institutions. Her debut concert at
                Java Jazz was in March 2007. In April 2007, she performed in
                Carnegie Hall, New York as a result of winning an international
                music competition in Italy the year before.
              </p>
              <p>
                From 2005 to 2011, Ivonne was a part-time lecturer at
                Universitas Pelita Harapan - Conservatory of Music. She also
                held the position of Dean of Music in Institut Musik Daya in
                2006, and Choir Director Jakarta International Community Choir
                (JICC) from 2006 to 2016.
              </p>
              <p>
                Aside from music, Ivonne is a nutrition nerd at heart. She is
                certified as a Holistic Nutritionist from AFPA (American Fitness
                Professionals &amp; Associates) in 2019.
              </p>
              <p>
                These days, she teaches private piano &amp; vocal students, and
                The Women’s Choir at MUSIC RÉPUBLICAIN.
              </p>
              <p>
                A firm believer that learning music can be a life-changing
                experience for everyone of all ages, Ivonne dedicates her time
                running MUSIC RÉPUBLICAIN with a team of 25 professional music
                teachers. Their collective vision is to deliver the most
                excellent music education to anyone who is simply willing to
                open their hearts.
              </p>
            </div>
          </div>
        </div>
      </SectionBackground>
      <SectionBackground bgPosition="right">
        <div className="container">
          <div className="row">
            <div className="col-md-3 order-md-last mx-auto">
              <img src={imgIvana} alt="" className="img-fluid rounded-circle" />
              <h3 className="my-3 text-center">Ivana Atmojo</h3>
            </div>
            <div className="col-md-8 order-md-first mx-auto">
              <p className="text-md-right">
                <b>Ivana Atmojo, MBA</b> is a personal brand coach, image &amp;
                style expert, happiness &amp; success strategist determined to
                help you build the outstanding personal brand you need to stand
                out and succeed. She works with thought-leaders, professionals
                and entrepreneurs from all over the world. She guides and
                encourages them to step forward in their full power as the face
                &amp; voice of their brands/businesses. By doing so, they’re
                able to realize their fullest potentials and make the positive
                impact they’re meant to make in the world. Ivana’s goal in life
                is to inspire as many people to have the courage to be more of
                who they are, to step up, and to transform their lives so they
                could be the happiest and most successful version of themselves.
                Gain access to bite-size personal branding tips for free at
                www.IvanaAtmojo.com and @IvanaAtmojo (Instagram).
              </p>
            </div>
          </div>
        </div>
      </SectionBackground>
      <section>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section_title text-center">
                <h2>Press</h2>
              </div>
              <div className="card-columns">
                {images.map((image, index) => (
                  <div role="button" tabIndex={index} key={image.id} className="card" onClick={() => handlePhotoClick(index)} onKeyDown={() => handlePhotoClick(index)}>
                    <img
                      className="w-100"
                      key={image.id}
                      src={image.src}
                      title={image.id}
                      alt={image.description}
                    />
                  </div>
                ))}
              </div>

              {isOpen && (
                <Lightbox
                  mainSrc={images[photoIndex].src}
                  nextSrc={images[(photoIndex + 1) % images.length].src}
                  prevSrc={
                    images[(photoIndex + images.length - 1) % images.length].src
                  }
                  onCloseRequest={toggleShow}
                  onMovePrevRequest={() =>
                    setPhotoIndex(
                      (photoIndex + images.length - 1) % images.length
                    )
                  }
                  onMoveNextRequest={() =>
                    setPhotoIndex((photoIndex + 1) % images.length)
                  }
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </section>
  );
};
